export const regexRegistrationNumberSE = /^[A-HJ-PR-UW-Z]{3}\d{2}[A-HJ-PR-UW-Z0-9]$/;
export const regexRegistrationNumberNO = /^[A-HJ-NPR-Z]{2}\d{5}$/;
export const regexEmail = /\S+@\S+\.\S+/;
export const regexNumber = /\D/g;
